import React, { useContext, useEffect, useState } from "react";
import ComboVote from "./ComboVote";
import { VoteMomoModal } from "./VoteMomoModal";
import { getDetailImage } from "../../../../store";
import { numberWithCommas } from "../../../../utils/common";
import Button from "../../../UI/Button";
import styled from "styled-components";
import { closeButton } from "./PriceModal";
import { ContestContext } from "../../../../App";
import { MAX_PRICE } from "../../../../config/constants";

const VoteModal = ({ missDetail, onClose, getPayUrl }) => {
  const [comboVote, setComboVote] = useState([]);

  const [payUrl, setPayUrl] = useState(null);
  const [configPayment, setConfigPayment] = useState("vnpay");

  const { contest } = useContext(ContestContext);

  useEffect(() => {
    const initOrder = [];

    const comboList = contest.comboList || [];

    comboList.map((c) =>
      initOrder.push({
        comboID: c.id,
        comboQty: 0,
        comboPoint: c.point,
        comboPrice: c.price,
      })
    );

    setComboVote(initOrder);
  }, []);

  const onHandleVote = async () => {
    if (!configPayment || comboVote.length === 0) {
      return;
    }

    try {
      const res = await getPayUrl(configPayment, missDetail.id, comboVote);

      setPayUrl(res.data?.url);
    } catch (error) {
      console.log("error when get pay Url", error);
      setPayUrl(null);
    }
  };

  const calTotal = () => {
    let totalPoint = 0;
    let totalPrice = 0;

    comboVote.map((c) => {
      totalPoint += c.comboQty * c.comboPoint;
      totalPrice += c.comboQty * c.comboPrice;
    });

    return { totalPoint, totalPrice };
  };

  return (
    <Styles>
      <div
        style={{
          position: "absolute",
          right: "0",
          cursor: "pointer",
        }}
        onClick={onClose}
      >
        {closeButton}
      </div>
      {payUrl && <VoteMomoModal payUrl={payUrl} onClose={onClose} />}
      {!payUrl && (
        <>
          <div style={{ marginBottom: "20px" }}>
            <img className="vm-logo" src="/images/bvote.png" alt="logo" />
          </div>
          <div>
            <h5 style={{ fontWeight: "600" }}>
              Bạn đang bình chọn cho thí sinh:
            </h5>
            <div className="vm-info">
              <div className="vm-info_img">
                <img
                  src={getDetailImage(missDetail.code)}
                  alt="logo"
                  style={{
                    objectFit: "cover",
                    objectPosition: "center",
                    maxWidth: "100%",
                  }}
                />
              </div>
              <div style={{ marginLeft: "12px" }}>
                <span
                  className="block w-full text-[16px] lg:text-[20px] "
                  style={{ fontWeight: "600", display: "block", width: "100%" }}
                >
                  SBD: {missDetail.code}
                </span>
                <p style={{ fontWeight: "600" }}>{missDetail.fullname}</p>
              </div>
            </div>
          </div>
          <div style={{ marginTop: "20px" }}>
            <h5 style={{ fontWeight: "600" }}>Chọn phương thức bình chọn:</h5>
            <div className="vm-method grid grid-cols-1 sm:flex px-[20px]">
              <div
                className="vm-method-item"
                style={
                  configPayment === "vnpay" ? { borderColor: "#ec7ca2" } : {}
                }
                onClick={() => {
                  setConfigPayment("vnpay");
                }}
              >
                <img
                  src="/images/vnpay.png"
                  alt="VNPAY"
                  className="vm-vnpay w-[40px] h-[40px] lg:w-[66px] lg:h-[66px] object-cover"
                />
              </div>
              {/*<div*/}
              {/*  className="vm-method-item"*/}
              {/*  style={configPayment === "cc" ? { borderColor: "#ec7ca2" } : {}}*/}
              {/*  onClick={() => {*/}
              {/*    setConfigPayment("cc");*/}
              {/*  }}*/}
              {/*>*/}
              {/*  <img*/}
              {/*    src="/images/visamaster.png"*/}
              {/*    alt="Visa / Master Card"*/}
              {/*    className="vm-visa w-[80px] h-[40px] lg:w-[120px] lg:h-[66px] object-cover"*/}
              {/*  />*/}
              {/*</div>*/}
              {/*  <div*/}
              {/*    className="vm-method-item"*/}
              {/*    style={*/}
              {/*      configPayment === "ewallet" ? { borderColor: "#ec7ca2" } : {}*/}
              {/*    }*/}
              {/*    onClick={() => {*/}
              {/*      setConfigPayment("ewallet");*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    <img*/}
              {/*      className="vm-ewallet"*/}
              {/*      src="/images/ewallet.png"*/}
              {/*      alt="E-Wallet"*/}
              {/*      width={66}*/}
              {/*      height={66}*/}
              {/*    />*/}
              {/*  </div>*/}
            </div>
          </div>

          <div style={{ marginTop: "20px" }}>
            <h5 style={{ fontWeight: "600" }}>Chọn gói điểm:</h5>
            <ComboVote comboVoteOrder={comboVote} setComboVote={setComboVote} />
          </div>
          <p
            className={
              calTotal().totalPrice > MAX_PRICE ? "error-message" : "error-none"
            }
          >
            Đơn hàng không được quá {numberWithCommas(MAX_PRICE)} đ
          </p>

          <div className="vm-footer">
            <div className="">
              <p style={{ fontSize: "16px" }}>
                Tổng số điểm :{" "}
                <span style={{ fontWeight: "600" }}>
                  {numberWithCommas(calTotal().totalPoint)} điểm
                </span>
              </p>
              <p style={{ fontSize: "16px" }}>
                Tổng số tiền:{" "}
                <span style={{ fontWeight: "600" }}>
                  {numberWithCommas(calTotal().totalPrice)} vnđ
                </span>
              </p>
            </div>
            <div className="vm-btn">
              <Button
                disabled={
                  calTotal().totalPrice > MAX_PRICE ||
                  calTotal().totalPrice === 0
                }
                onClick={() => {
                  onHandleVote();
                }}
              >
                Bình chọn
              </Button>
            </div>
          </div>
        </>
      )}
    </Styles>
  );
};

const Styles = styled.div`
  position: relative;
  padding: 20px;

  .vm-logo {
    height: 20px;
  }

  .vm-info {
    display: flex;
    align-items: center;
    margin-top: 16px;
    padding: 6px 0 6px 24px;
    background-color: #fcf3f9;
    border-radius: 12px;
  }

  .vm-info_img {
    position: relative;
    width: 68px;
    height: 68px;
    border-radius: 9999px;
    overflow: hidden;
  }

  .vm-method {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-top: 12px;

    .vm-vnpay {
      height: 66px;
      width: 66px;
    }

    .vm-visa {
      width: 120px;
      height: 66px;
    }

    .vm-method-item {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-left: 12px;
      padding-right: 12px;
      border-width: 1px;
      border-style: solid;
      border-radius: 12px;
      cursor: pointer;
      border-color: #fff;
    }
  }

  .vm-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 28px;
  }

  .close-button {
    position: absolute;
    top: -20px;
    right: 0px;
    cursor: pointer;
  }

  .error-none {
    visibility: hidden;
    font-size: 16px;
    margin-top: 8px;
  }

  .error-message {
    color: red;
    text-align: center;
    font-size: 16px;
    margin-top: 8px;
  }

  @media only screen and (max-width: 640px) {
    .vm-method {
      display: flex;
      justify-content: space-between;
      gap: 5px;

      .vm-vnpay {
        height: 40px;
        width: 40px;
      }

      .vm-visa {
        width: 80px;
        height: 50px;
      }

      .vm-ewallet {
        width: 40px;
        height: 40px;
      }

      .vm-method-item {
        width: 100%;
        display: flex;
        padding-left: 6px;
        padding-right: 6px;
      }
    }

    .vm-footer {
      flex-direction: column;
      row-gap: 20px;
    }
    .vm-btn {
      margin-bottom: 15px;
    }
  }
`;

export default VoteModal;
